import React from "react";
import "./Header.scss";

const WebPicture = ({ data }) => {
  let webp_src = data.webp;
  if (webp_src.indexOf(".svg") > -1) {
    webp_src = "";
  }
  return (
    <picture loading="lazy" className={data.class}>
      <source srcSet={webp_src} type="image/webp" />
      <source srcSet={data.img} type="image/jpg" />
      <img
        loading={"lazy"}
        src={data.img}
        alt={data.title}
        width={data.width}
        height={data.height}
      />
    </picture>
  );
};

export default WebPicture;
